import PublicLayout from 'layouts/PublicLayout';
import ProfileManagement from 'pages/private/ProfileManagement/ProfileManagement';
import Loading from 'pages/shared/Loading';
import { Navigate } from 'react-router-dom';
import { Session } from 'types';
import { isWorkoutTrackerEnabled } from 'utils/workoutTracker';

import { getAthleteRouteMap } from './athlete';
import { getKiloStaffRouteMap } from './kilo-staff';
import { getKioskRouteMap } from './kiosk';
import { getSalesPortalRouteMap } from './sales-portal';
import { getStaffRouteMap } from './staff';
import { IRouteMap } from './types';
import { getUnauthenticatedRouteMap } from './unauthenticated';

export const loadingRouteMap: IRouteMap = {
  layout: PublicLayout,
  routes: [
    {
      key: 'loading',
      component: Loading,
      path: '*',
    },
  ],
  navLinks: [],
};

export const profileSelectionRouteMap: IRouteMap = {
  layout: PublicLayout,
  routes: [
    {
      key: 'profile-selection',
      component: ProfileManagement,
      path: '/',
    },
    {
      key: 'redirect',
      component: () => Navigate({ to: '/' }),
      path: '*',
    },
  ],
  navLinks: [],
};

export const getRouteMapList = (
  session: Session | null,
  isLoading: boolean,
  isKiosk: boolean,
  isDesktop: boolean,
  hasPerm: (permission: string) => boolean,
): IRouteMap[] => {
  if (isLoading) return [loadingRouteMap];

  const isDemoGym = !!session?.demoGym;
  const salesPortalRoutes = isDemoGym ? [] : [getSalesPortalRouteMap()];

  if (!session) return [getUnauthenticatedRouteMap(), ...salesPortalRoutes];

  if (isKiosk) return [getKioskRouteMap(isWorkoutTrackerEnabled(session.gym?.workoutTrackerEnabled))];

  if (!session.profile) return [profileSelectionRouteMap, ...salesPortalRoutes];

  if (session.role === 'kilo_staff')
    return [getKiloStaffRouteMap(!!session?.kiloStaff?.isSalesTeam), ...salesPortalRoutes];

  if (session.role === 'owner' || session.role === 'staff') {
    // GLM is available when the gym has a real connection or is a demo gym (simulated experience).
    const glmEnabled = !!session.gym?.ghlV2Enabled || isDemoGym;
    return [
      getStaffRouteMap(session.role, session.gym, hasPerm, isDesktop, glmEnabled),
      ...salesPortalRoutes,
    ];
  }

  if (session.role === 'athlete') return [getAthleteRouteMap(), ...salesPortalRoutes];

  return [];
};
